import React from 'react'
import Head from 'next/head'

export const PageHead = () => (
  <Head>
    <title>Find Developers</title>
    <link rel="canonical" href="https://www.offerzen.com/employers/find-developers" />

    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="robots" content="noindex" />
    <meta name="description" content="The job marketplace that helps you find remote and onsite developers that are ready to interview." />

    <meta property="og:title" content="Find job-seeking software developers across Europe and Africa" />
    <meta property="og:site_name" content="OfferZen" />
    <meta
      property="og:description"
      content="The job marketplace that helps you find remote and onsite developers that are ready to interview."
    />
    <meta property="og:url" content="https://www.offerzen.com/employers/find-developers" />
    <meta property="og:image" content="https://www.offerzen.com/employers/find-developers/assets/meta-image.png" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Find job-seeking software developers across Europe and Africa" />
    <meta name="twitter:image" content="https://www.offerzen.com/employers/find-developers/assets/meta-image.png?1234121" />
    <meta
      name="twitter:description"
      content="The job marketplace that helps you find remote and onsite developers that are ready to interview."
    />
    <meta name="twitter:image:alt" content="Find job-seeking software developers across Europe and Africa" />
    <meta name="twitter:site" content="@OfferZen" />

    <link rel="icon" href={`${process.env.NEXT_PUBLIC_BASEPATH}/favicon.ico`} />
    <link rel="shortcut icon" type="image/x-icon" href={`${process.env.NEXT_PUBLIC_BASEPATH}/favicon-32x32.png`} />
    <link rel="icon" type="image/png" href={`${process.env.NEXT_PUBLIC_BASEPATH}/favicon-16x16.png`} sizes="16x16" />
    <link rel="icon" type="image/png" href={`${process.env.NEXT_PUBLIC_BASEPATH}/favicon-32x32.png`} sizes="32x32" />
    <link rel="icon" type="image/png" href={`${process.env.NEXT_PUBLIC_BASEPATH}/favicon-96x96.png`} sizes="96x96" />
    <link rel="icon" type="image/png" href={`${process.env.NEXT_PUBLIC_BASEPATH}/favicon-128x128.png`} sizes="128x128" />
    <link rel="icon" type="image/png" href={`${process.env.NEXT_PUBLIC_BASEPATH}favicon-196x196.png`} sizes="196x196" />
    <link rel="stylesheet" href="https://use.typekit.net/qjg5occ.css" />
  </Head>
)
